module.exports = __webpack_public_path__ + "img/Barlow-Medium.598ea28e.svg";